export default function (_this) {
  return {
    create (name, cb) {
      const key = _this.getRef('workflow')
        .push({ name, data: '' }, () => {
          cb(key)
        }).key
    },
    read (cb) {
      _this.getRef('workflow').on('value', (snapshot) => {
        cb(snapshot.val())
      })
    },
    save (key, data) {
      _this.getRef('workflow')
        .child(key)
        .child('data')
        .set(JSON.stringify(data))
    },
    remove (key, cb) {
      _this.getRef('workflow')
        .child(key)
        .remove(() => {
          if (cb) cb()
        })
    }
  }
}
